// DetailsPlatModal.js
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const DetailsPlatModal = ({ selectedPlat, categoriesMap, onClose }) => {
    return (
        <Modal show={true} onHide={onClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Détails de {selectedPlat.nom}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-4">
                            <img src={selectedPlat.image} alt={selectedPlat.nom} className="img-fluid mb-3 img-plat2" />
                     
                        </div>
                        <div className="col-md-8">
                            <h5><strong className='org-clr'>{selectedPlat.nom}</strong></h5>
                            <p><strong>Catégorie:</strong> {categoriesMap[selectedPlat.categorie] || selectedPlat.categorie}</p>
                            <p><strong>Description:</strong><span style={{ whiteSpace: 'pre-line' }}>{selectedPlat.description}</span> </p>
                            <p><strong>Prix:</strong>  {selectedPlat?.prixType === 'variable' 
                                                ? selectedPlat.sizes.map(size => `${size.taille} : ${size.prix}€`).join(' , ') 
                                                : `${selectedPlat.prix}€`}
                            </p>
                            <p><strong>Disponible:</strong> {selectedPlat.disponible ? 'Oui' : 'Non'} , <strong>Végétarien:</strong> {selectedPlat.vegitarienne ? 'Oui' : 'Non'} </p>
                         
                        </div>
                        <hr />
                        {selectedPlat?.addons && selectedPlat.addons.length > 0 && (
                         <div>   
                        <h5 className='org-clr'>Module supplémentaires</h5>
                        {selectedPlat.addons.map((addon, index) => (
                           
                            <div className="col-md-4" key={index}>
                            <strong>{addon.nom}</strong>
                            {addon.modules.map((module, modIndex) => (
                                <div key={modIndex} >
                                <p> {module.nom} - {module.prix} €</p>
                                
                                </div>
                            ))}
                            </div>
                        ))}
                        </div>
                        )}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>Fermer</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DetailsPlatModal;
